// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useAuthAction } from '@ywfe/authmodules';
import { Modal } from 'antd';
import { YAuth } from './auth';
import WebFooter from './WebFooter';
import { LoginVideo } from './loginVideo';
import { LoginStyle, ModalStyle } from './login.styles';

// 是否平板
const isTabletInApp = window.screen.width < 850;

const tabList = [
  {
    name: '首页',
    url: '',
  },
  {
    name: '遥望官网',
    url: 'https://www.yowant.com/',
  },
  {
    name: '遥望云链',
    url: 'https://srm-supplier.ywwl.com/',
  },
  {
    name: '遥望知识库',
    url: 'https://zh3vobp856.feishu.cn/wiki/OyvMwpieOiYCCvk9FT9cVUF1nQg',
  },
];

export const Login: React.FC = () => {
  const { actionCodeLogin, actionLoginAuto } = useAuthAction();
  const isWXWork = /wxwork/i.test(navigator.userAgent);
  const isInFeishu = /Lark/i.test(navigator.userAgent);
  const nowUrl = new URL(window.location.href);
  const targetUrl = nowUrl.searchParams.get('targetUrl');
  const redirectUrl = nowUrl.searchParams.get('redirectUrl');
  const [modalVisible, setModalVisible] = useState(false);
  const GetQueryString = (name: string) => {
    const url = window.location.href;
    const reg = new RegExp(`(\\?|&)${name}=([^&]*)(&|$)`, 'i');
    const r = url.match(reg);

    if (r !== null) {
      return unescape(r[2]);
    }
    return '';
  };

  const isAutoLogin =
    isWXWork || (isInFeishu && GetQueryString('code')) || (GetQueryString('code') && ['WX_WORK', 'FEISHU'].includes(GetQueryString('fromPlat')));

  // tab点击
  const tabClick = (item: any) => {
    if (item.url) {
      window.open(item.url);
    }
  };

  useEffect(() => {
    // 企业微信环境才自动登录
    if (isAutoLogin) {
      window.localStorage.setItem('token', '');
      const FEISHU = isInFeishu || GetQueryString('fromPlat') === 'FEISHU';
      // 自动登录

      if (GetQueryString('code')) {
        actionCodeLogin(FEISHU);
      } else {
        if (redirectUrl) {
          nowUrl.searchParams.set('redirectUrl', redirectUrl);
        }
        if (targetUrl) {
          nowUrl.searchParams.set('redirectUrl', targetUrl);
        }
        nowUrl.searchParams.set('grayPlatform', 'PC');
        actionLoginAuto(nowUrl.toString());
      }
    }
  }, []);

  return (
    <>
      {isAutoLogin ? (
        <></>
      ) : (
        <LoginStyle>
          {isTabletInApp ? (
            <div className="tablet-type-login">
              <img className="logo" src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/yun/yun-logo.png" alt="" />
              <YAuth type="login" style={{ left: '50%' }} id="modal_login_wx_container" />
            </div>
          ) : (
            <>
              <div className="top-bar">
                <img className="logo" src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/yun/yun-logo.png" />
                <div className="tab">
                  {tabList.map((item, index) => (
                    <div className={`tab-item${!index ? ' active' : ''}`} onClick={() => tabClick(item)}>
                      {item.name}
                    </div>
                  ))}
                </div>
              </div>
              <div className="login-outer">
                <div className="login-container">
                  <img className="back-img" src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/yun/yun-login-back-1440.png" />
                  <div className="login-inner">
                    <div className="login-text">
                      <div className="login-title">遥望云-全场景数智化协作平台</div>
                      <div className="login-subtitle">直播全流程数字化平台，轻松工作，高效协同。</div>
                    </div>
                    {/* todo 登录框组件 */}
                    <YAuth type="login" />
                  </div>
                  {/* <div className="login-box"></div> */}
                </div>
              </div>
              <img className="advantage-img" src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/yun/login-advantage.png" />
              <img className="middle-img" src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/yun/login-01@2x.png" />
              <img className="middle-img" src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/yun/login-02@2x.png" />
              <img className="middle-img" src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/yun/login-03@2x.png" />
              <img className="middle-img" src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/yun/login-04@2x.png" />
              <img className="middle-img" src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/yun/login-05@2x.png" />
              <div className="bottom-img">
                <img className="middle-img" src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/yun/login-06@2x.png" />
                <div
                  className="bottom-login-btn"
                  onClick={() => {
                    setModalVisible(true);
                  }}
                >
                  立即登录
                </div>
                <ModalStyle
                  visible={modalVisible}
                  title={null}
                  onOk={() => {}}
                  onCancel={() => {
                    setModalVisible(false);
                  }}
                  footer={null}
                  width={350}
                >
                  <YAuth type="login" style={{ left: '50%' }} id="modal_login_wx_container" />
                </ModalStyle>
              </div>
              <WebFooter />
            </>
          )}
        </LoginStyle>
      )}
    </>
  );
};
